export const breadcrumbsRoutes = [
    //MAIN_PAGE
    // {}
    { path: "/", breadcrumb: "" },
    { path: "/main", breadcrumb: "Главная" },
    { path: "/profile", breadcrumb: "Профиль" },
    { path: "/knowledge-base", breadcrumb: "База знаний" },
    { path: "/help", breadcrumb: "Помощь" },
    { path: "/divisions", breadcrumb: "Мое поздразделение" },

    //HR_SERVICES
    { path: "/main/hr-services", breadcrumb: "Кадровый сервис" },
    {
        path: "/main/hr-services/reward",
        breadcrumb: "Заработная плата",
    },
    {
        path: "/main/hr-services/reward/payroll",
        breadcrumb: "Расчетный лист",
    },
    { path: "/main/hr-services/requests", breadcrumb: "Заявки" },
    { path: "/main/hr-services/work-time", breadcrumb: "Рабочее время" },
    { path: "/main/hr-services/layoff", breadcrumb: "Увольнение" },
    {
        path: "/main/hr-services/requests/leader",
        breadcrumb: "Заявки руководителя",
    },
    {
        path: "/main/hr-services/requests/leader/15",
        breadcrumb: "Прохождение неоплачиваемой практики студентом ВУЗа",
    },
    {
        path: "/main/hr-services/requests/leader/16",
        breadcrumb: "Премирование за выполнение ОВЗ",
    },
    {
        path: "/main/hr-services/requests/leader/21",
        breadcrumb: "Привлечение к работе в выходные и праздничные дни",
    },
    {
        path: "/main/hr-services/requests/leader/22",
        breadcrumb: "Установление индивидуальных коэффициентов",
    },
    {
        path: "/main/hr-services/work-time/requests",
        breadcrumb: "Заявки по рабочему времени",
    },
    {
        path: "/main/hr-services/layoff/request",
        breadcrumb: "Заявка на увольнение",
    },
    {
        path: "/main/hr-services/reward",
        breadcrumb: "Вознаграждения",
    },
    {
        path: "/main/hr-services/work-time/local-trips",
        breadcrumb: "Журнал местных командировок",
    },
    {
        path: "/main/hr-services/work-time/local-trips/create",
        breadcrumb: "Оформить",
    },
    {
        path: "/main/hr-services/reward/payroll",
        breadcrumb: "Расчетный лист",
    },
    {
        path: "/main/hr-services/work-time/holidays",
        breadcrumb: "Отпуска и дни отдыха",
    },
    {
        path: "/main/hr-services/work-time/work-schedule",
        breadcrumb: "График работы",
    },
    {
        path: "/main/hr-services/work-time/sout",
        breadcrumb: "СОУТ",
    },
    {
        path: "/main/hr-services/work-time/sout/guarantee-compensation",
        breadcrumb: "Гарантии и компенсации работнику",
    },
    {
        path: "/main/hr-services/work-time/sout/harmful-factors",
        breadcrumb: "Оценка условий труда по вредным (опасным) факторам",
    },
    //MAIN_REFERENCES
    {
        path: "/main/references",
        breadcrumb: "Заказ справок",
    },
    {
        path: "/main/references/salary",
        breadcrumb: "Заказ справок о заработной плате",
    },
    //MAIN__USEFUL-LINKS->
    {
        path: "/main/useful-links",
        breadcrumb: "Полезные ссылки",
    },
    //PROFILE
    { path: "/profile/personal-data", breadcrumb: "Персональные данные" },
    { path: "/profile/service-data", breadcrumb: "Служебные данные" },
    { path: "/profile/personal-documents", breadcrumb: "Документы" },
    {
        path: "/profile/evaluation-information",
        breadcrumb: "Информация об оценке",
    },
    { path: "/profile/eds-release", breadcrumb: "Электронная подпись" },
    {
        path: "profile/eds-release/unep",
        breadcrumb: "Усиленная неквалифицированная электронная подпись",
    },
    { path: "profile/eds-release/unep/release", breadcrumb: "Получить УНЭП" },

    //divisions

    { path: "/divisions/work-time", breadcrumb: "Рабочее время сотрудников" },
    { path: "/divisions/work-time/holidays", breadcrumb: "Отпуска и дни отдыха" },
    { path: "/divisions/structure", breadcrumb: "Структура подразделения" },
    { path: "/divisions/structure/employee-list", breadcrumb: "Список сотрудников" },
    { path: "/divisions/structure/delegation", breadcrumb: "Замещение" },
    { path: "/divisions/structure/delegation/transfer", breadcrumb: "Передача полномочий" },
    { path: "/divisions/structure/delegation/revoke", breadcrumb: "Прекращение замещения" },
    { path: "/divisions/structure/request-delegation", breadcrumb: "Делегирование полномочий" },
    { path: "/divisions/structure/request-delegation/transfer", breadcrumb: "Передача полномочий" },
    { path: "/divisions/structure/request-delegation/revoke", breadcrumb: "Прекращение замещения" },
    { path: "/divisions/structure/request-delegation/revoke/:id", breadcrumb: "Прекращение замещения" },
];

